import { Routes } from "@angular/router";
import { CwtLoggedInGuard } from "@cawita/core-front/auth";

export default [
    { path: 'auth', loadChildren: () => import('./auth/auth.routes') },
    { path: '',  canActivate: [CwtLoggedInGuard], loadChildren: () => import('./main/main.routes') }
] as Routes;